import React, { FC } from "react";
import { Controller } from "react-hook-form";

import {
  validateCustomFieldMaxValue,
  validateCustomFieldMinValue,
  validateUniqueCustomField,
} from "../../common/utils/form";
import Text, { TextVariant } from "../../components/Display/Text";
import NumberInput from "../../components/DataInput/NumberInput";
import { FieldControllerPropsBase } from "./Onboarding";

type VerificationDateControllerProps = FieldControllerPropsBase & {
  customFieldValue?: number | string | null;
  enrichedCustomFieldValue?: number | string | null;
};

const VerificationDate: FC<VerificationDateControllerProps> = ({
  control,
  errors,
  customFieldValue,
  enrichedCustomFieldValue,
  setValue,
}) => {
  return (
    <div className="d-flex flex-column gap-4 align-items-center">
      <Text variant={TextVariant.sm} className="text-center">
        Choose a custom field for us to mark with the date each prospect&apos;s
        email was verified
      </Text>
      <div className="w-40">
        <Controller
          name="organizationSettings.timestampCustomField"
          control={control}
          rules={{
            validate: (value) =>
              validateUniqueCustomField({
                isEnabled: true,
                value: value?.toString() || "",
                otherValues: [
                  customFieldValue?.toString() || "",
                  enrichedCustomFieldValue?.toString() || "",
                ],
              }),
            min: validateCustomFieldMinValue({ minValue: 1, isEnabled: true }),
            max: validateCustomFieldMaxValue({
              maxValue: 150,
              isEnabled: true,
            }),
          }}
          render={({ field: { ref, value } }) => {
            // Onboarding is only for Outreach, so value should be a number
            const numericValue = typeof value === 'number' ? value : (typeof value === 'string' ? parseInt(value, 10) || undefined : undefined);
            return (
              <NumberInput
                label="Verification date"
                inputRef={ref}
                value={numericValue}
                onChange={(value: number) => {
                  setValue("organizationSettings.timestampCustomField", value);
                }}
                error={!!errors.organizationSettings?.timestampCustomField}
                helperText={
                  errors.organizationSettings?.timestampCustomField?.message
                }
              />
            );
          }}
        />
      </div>
    </div>
  );
};

export default VerificationDate;
